import { instance } from "api/apiBase";

interface DwellsyStatusResponse {
  connected: boolean;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/dwellsy";

export const dwellsyApi = {
  getStatus: async (): Promise<DwellsyStatusResponse> => {
    const { data } =
      await instance.get<DwellsyStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<DwellsyStatusResponse> => {
    const { data } =
      await instance.post<DwellsyStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  disconnect: async (): Promise<DwellsyStatusResponse> => {
    const { data } =
      await instance.delete<DwellsyStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
